// Umbra Void — Reveal on scroll
// Per handoff homepage HTML line 1708 + Shopify Theme Editor events
// Fixed per May audit UV-RA-1: guard document.body, include root-self match
(function(){
  if (!('IntersectionObserver' in window)) {
    var nodes = document.querySelectorAll('.uv-reveal');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('uv-in');
    return;
  }
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('uv-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  var OBSERVED = 'data-uv-observed';
  function observeOne(el){
    if (!el || el.getAttribute(OBSERVED)) return;
    el.setAttribute(OBSERVED, '1');
    observer.observe(el);
  }
  function observeNew(root){
    var scope = root || document;
    // Include the root itself if it matches (per May UV-RA-1)
    if (scope.classList && scope.classList.contains('uv-reveal')) observeOne(scope);
    var nodes = scope.querySelectorAll ? scope.querySelectorAll('.uv-reveal:not([' + OBSERVED + '])') : [];
    for (var i = 0; i < nodes.length; i++) observeOne(nodes[i]);
  }
  function attachMutationObserver(){
    if (!('MutationObserver' in window) || !document.body) return;
    new MutationObserver(function(){ observeNew(); }).observe(document.body, {
      childList: true, subtree: true,
    });
  }
  function init(){
    observeNew();
    attachMutationObserver();
  }
  // Guard document.body: script may load before body exists when injected in <head>
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  // Shopify Theme Editor events
  document.addEventListener('shopify:section:load', function(e){ observeNew(e.target); });
  document.addEventListener('shopify:section:reorder', function(){ observeNew(); });
  document.addEventListener('shopify:section:select', function(e){
    var hits = e.target.classList && e.target.classList.contains('uv-reveal')
      ? [e.target].concat(Array.prototype.slice.call(e.target.querySelectorAll('.uv-reveal')))
      : Array.prototype.slice.call(e.target.querySelectorAll('.uv-reveal'));
    for (var i = 0; i < hits.length; i++) hits[i].classList.add('uv-in');
  });
})();
